import Axios from "axios";

const CompanyServices = {
  async create(params) {
    try {
      const res = await Axios.post("company/create", params);
      return res.data;
    } catch (err) {
      throw err.response.data;
    }
  },
  async findAll(params) {
    try {
      const res = await Axios.post("company/all", params);
      return res.data;
    } catch (err) {
      throw err.response.data;
    }
  },
  async findOne(params) {
    try {
      const res = await Axios.post("company/one", params);
      return res.data;
    } catch (err) {
      throw err.response.data;
    }
  },
  async delete(params) {
    try {
      const res = await Axios.post("company/delete", params);
      return res.data;
    } catch (err) {
      throw err.response.data;
    }
  },
  async update(params) {
    try {
      const res = await Axios.post("company/update", params);
      return res.data;
    } catch (err) {
      throw err.response.data;
    }
  },
  async findList() {
    try {
      const res = await Axios.post("company/list");
      return res.data;
    } catch (err) {
      throw err.response.data;
    }
  },
};

export default CompanyServices;
